<template>
    <img src="@images/portal/mailing-empty.svg" alt="" />
</template>
<script>
export default {
    name: "MailingEmptyInboxIcon"
}
</script>
